//Current Date data
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/vehiclenokm/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";

import Layouts from "../../layouts/layouts";
import VehicleNoKmDetailModal from "../../components/vehiclenokm/Vehicle Details";

// ✅ Get Today IST Date
const getTodayIST = () => {
  const now = new Date();
  const istOffset = 5.5 * 60 * 60 * 1000;
  const istNow = new Date(now.getTime() + istOffset);

  const year = istNow.getUTCFullYear();
  const month = String(istNow.getUTCMonth() + 1).padStart(2, "0");
  const day = String(istNow.getUTCDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export default function VehicleNoKm() {
  const navigate = useNavigate();

  const title = "Vehicle With 0Km Details";

  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);

  const [showVehicleDetailModal, setShowVehicleDetailModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const [selectedDate, setSelectedDate] = useState("");

  const brad = [{ name: "Home" }, { name: title }];

  // ✅ Columns (same as your API response)
  const columns = [
    {
      name: <b>Vehicle Number</b>,
      selector: (row) => row.numberplate,
      sortable: true,
    },
    {
      name: <b>Total Km</b>,
      selector: (row) => Number(row.dailyKm || 0).toFixed(2),
      sortable: true,
    },
    {
      name: <b>Current Driver</b>,
      selector: (row) => row.current_driver || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: <b>Last Driver</b>,
      selector: (row) => row.last_driver || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: <b>Clients</b>,
      selector: (row) => row.clients || "-",
      sortable: false,
      wrap: true,
    },
    {
      name: <b>Hub</b>,
      selector: (row) => row.hub,
      sortable: true,
    },
    {
      name: <b>Company</b>,
      selector: (row) => row.company,
      sortable: true,
    },
    {
      name: <b>Leasing Partner</b>,
      selector: (row) => row.leasing_partner,
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <button
          onClick={() => viewVehicle(row)}
          className="btn btn-primary btn-sm ms-1"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
  ];

  const getYesterdayIST = () => {
    const now = new Date();

    // Convert to IST (UTC +5:30)
    const istOffset = 5.5 * 60; // minutes
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const istTime = new Date(utc + istOffset * 60000);

    // Subtract 1 day
    istTime.setDate(istTime.getDate() - 1);

    // Format YYYY-MM-DD
    return istTime.toISOString().split("T")[0];
  };

  const fetchData = async (customDate) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const date = customDate || getYesterdayIST(); // ✅ yesterday by default
      setSelectedDate(date);

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/vehicle-nokm?date=${date}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success && Array.isArray(response.data.data)) {
        setApiState(response.data.data);
      } else {
        console.error("Unexpected API response", response.data);
        setApiState([]);
      }

      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ View Modal
  const viewVehicle = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowVehicleDetailModal(true);
  };

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const handleDateChange = async (date) => {
    setSelectedDate(date);
    await fetchData(date);
  };

  const exportToExcel = () => {
    const transformedData = apistate.map((data) => ({
      Date: data.date,
      "Vehicle Number": data.numberplate,
      DailyKm: data.dailyKm,
      Company: data.company,
      "Leasing Partner": data.leasing_partner,
      "Hub Name": data.hub,
      "Current Driver": data.current_driver || "-",
      "Last Driver": data.last_driver || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Vehicles");

    XLSX.writeFile(workbook, "vehicles.xlsx");
  };

  return (
    <>
      <Layouts />

      <Status_modal row={selectVal} openModal={openModal} />

      <VehicleNoKmDetailModal
        show={showVehicleDetailModal}
        onHide={() => setShowVehicleDetailModal(false)}
        data={selectedVehicle}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {/* ✅ Showing Date */}
                {/* <h6 style={{ marginBottom: "10px" }}>
                  Showing data for: <b>{selectedDate}</b>
                </h6> */}
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#f1f3ff",
                    border: "1px solid #d6dcff",
                    padding: "8px 14px",
                    borderRadius: "8px",
                    marginBottom: "12px",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ color: "#555" }}>📅 Showing data for</span>
                  <span
                    style={{
                      fontWeight: "600",
                      color: "#4723d9",
                    }}
                  >
                    {selectedDate}
                  </span>
                </div>
                <DataTable_Component
                  searchBy="numberplate"
                  title_btn={true}
                  title="Vehicle List"
                  apidata={apistate}
                  columns={columns}
                  onDateChange={handleDateChange}
                  selectedDate={selectedDate}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
